export default __webpack_public_path__ + "static/media/welcome-users.1986b402.png";